import classNames from 'classnames'
import styles from './styles/BlurOver.css'

export const BlurOver = ({
  className,
  show = true,
  foreground = () => null,
  hoverEffect = false,
  bgStyle = { hide: {}, show: {} },
  children,
  ...rest
}) => (
  <div className={classNames(styles.blurOver, className)} {...rest}>
    <div
      className={classNames(styles.fgWrapper, {
        [styles.fgShow]: show
      })}
    >
      {show && foreground()}
    </div>
    <div
      className={
        classNames(styles.bgWrapper, {
          [styles.bgShow]: show,
          [styles.hoverEffect]: show && hoverEffect
        })
      }
      style={show ? bgStyle.show || {} : bgStyle.hide || {}}
    >
      {children}
    </div>
  </div>
)

export default BlurOver
